/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {PartyProfileDto} from "./partyProfileDto.zod";

export const UnregisteredCompanyDto = zod.object({
  companyName: zod.string(),
  partyProfile: PartyProfileDto,
});

export type UnregisteredCompanyDto = zod.input<typeof UnregisteredCompanyDto>;
export type UnregisteredCompanyDtoOutput = zod.output<typeof UnregisteredCompanyDto>;
